var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reader"},[_c('h1',[_vm._v("Scan a event QR code")]),_c('QrcodeStream',{staticClass:"qr-reader",on:{"decode":_vm.onDecode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }